import React from "react";
import { Controller } from "react-hook-form";
import InputField from "../inputField/InputField";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { FormProps } from "../../types/types";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import get from "lodash.get";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const Form: React.FC<FormProps> = ({
  fields,
  errors,
  onClick,
  isSubmitting,
  method,
  style,
  options = {},
}) => {
  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: any) => void
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      onChange(event.target.files[0]);
    }
  };

  return (
    <form {...method} className="w-full">
      <div
        className={`w-full ${
          style ? style : "sm:w-4/5 md:w-2/3 lg:w-1/2"
        }`}
      >
        {fields.map((field, i) => {
          const errorMsg = get(errors, field.name)?.message;

          return (
            <div key={i} className="mb-4">
              <label className="block mb-2 font-medium">{field.label}</label>
              <Controller
                name={field.name}
                control={method.control}
                render={({ field: controllerField }) => {
                  switch (field.type) {
                    case "dropdown":
                      return (
                        <Select
                          onValueChange={controllerField.onChange}
                          defaultValue={controllerField.value}
                        >
                          <SelectTrigger className="w-full flex-1 col-span-2">
                            <SelectValue
                              placeholder={`Select ${field.placeholder}`}
                            />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              <SelectLabel>
                                {`Select ${field.label}`}
                              </SelectLabel>
                              {options[field.name]?.map(
                                (option: any, idx: number) => (
                                  <SelectItem
                                    key={idx}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </SelectItem>
                                )
                              )}
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                      );

                    case "image":
                      return (
                        <>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageChange(e, controllerField.onChange)
                            }
                            className="border border-gray-200 px-4 py-2 rounded w-full"
                          />
                          {controllerField.value && (
                            <img
                              src={URL.createObjectURL(
                                controllerField.value
                              )}
                              alt="Selected"
                              className="mt-2 w-20 h-20 object-cover"
                            />
                          )}
                        </>
                      );

                    case "time":
                      return (
                        <TimePicker
                          onChange={controllerField.onChange}
                          value={controllerField.value}
                          disableClock={true}
                          className="w-full"
                        />
                      );

                    default:
                      return (
                        <InputField
                          {...field}
                          {...controllerField}
                          style="border border-gray-200 px-4 py-2 rounded w-full"
                        />
                      );
                  }
                }}
              />
              {errorMsg && (
                <p className="text-red-500 text-xs mt-1">{errorMsg}</p>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8">
        <Button
          type="submit"
          className="w-full"
          disabled={isSubmitting}
          onClick={onClick}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="animate-spin mr-2" />
              Please wait
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </div>
    </form>
  );
};

export default Form;
